import { memo } from 'react';
import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import * as icons from '@gn-audio/icons';
import { getTitle } from '@gn-audio/jss-core';

import { JabraFocusItem } from '../../JabraFocus';
import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { MinorLinksCategory } from '../megaMenuTypes';

type MinorLinksCategoryProps = {
  category: MinorLinksCategory;
  displayVersion: string;
};

const MinorLinksCategoryItemComponent = ({
  category,
  displayVersion,
}: MinorLinksCategoryProps): React.JSX.Element => {
  const minorLinks = category.MinorLinks;
  const categoryName = category.Label?.value;
  const hasAtLeastOneFilledLink = minorLinks?.some((minorLink) => minorLink.Link);

  return (
    <>
      {hasAtLeastOneFilledLink && (
        <div className="minor-links-category flex-1">
          <span className="flex text-black">{categoryName}:</span>
          <ul className="flex flex-row flex-wrap gap-2 pb-2 pt-2">
            {minorLinks?.map((minorLink) => {
              const minorLinkField: LinkField | undefined = minorLink.Link;
              if (!minorLinkField) {
                return null;
              }

              const minorLinkTitle = getTitle(minorLink) || '';
              const minorLinkIconName = minorLink.IconName;
              return (
                <li key={minorLinkTitle}>
                  <JabraFocusItem asChild>
                    <a
                      href={minorLinkField?.value?.href}
                      className={`border-box flex-0 flex cursor-pointer items-center rounded-lg bg-white p-1 pl-2 pr-2 focus-visible:rounded-lg ${displayVersion}`}
                    >
                      {!!minorLinkIconName?.value && (
                        <JabraIcon
                          className="relative bottom-[1px] mr-2 size-6"
                          Icon={icons?.[minorLinkIconName.value]}
                        />
                      )}
                      <span>{minorLinkTitle}</span>
                    </a>
                  </JabraFocusItem>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
};

export const MinorLinksCategoryItem = memo(MinorLinksCategoryItemComponent);
